import { defineAsyncComponent, markRaw } from "vue";

export default function useShiftCoverVolunteerSequence(
  context,
  submitCallback,
) {
  /* v8 ignore start */
  if (!context.shift) {
    throw new Error(
      "Shift context is required for Shift Cover Volunteer Sequence.",
    );
  }
  /* v8 ignore end */

  const formSequence = [
    {
      id: "end",
      final: true,
      component: markRaw(
        defineAsyncComponent(
          () =>
            import("@/components/form/sequences/ShiftCoverVolunteerCheck.vue"),
        ),
      ),
      props: {
        shift: context.shift,
        activities: context.activities,
        currentRotas: context.currentRotas,
      },
      next: async (answer, answers, context) => {
        const result = await submit(context, answers);

        /* v8 ignore next 10 */
        if (result !== false) {
          return {
            nextStepId: null,
            success: true,
          };
        }
        return {
          nextStepId: null,
          success: false,
        };
      },
    },
  ];

  const submit = async (context) => {
    return submitCallback({
      shiftId: context.shift.id,
    });
  };

  return {
    formSequence,
  };
}
